
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function replaceAll(find, replace) {
    return this.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = replaceAll;
}

window.$isMobile = window.matchMedia('(max-width: 768px)').matches
window.$isSmallPC = window.matchMedia('(max-width: 1200px) and (min-width: 768px)').matches
if(!window.filtersCookieName) {
    window.filtersCookieName = `RE-filters`;
}
window.tnsPlugin = window.tns;
window.tns = async (...args) => {
    try {
        return window.tnsPlugin(...args);
    } catch (e) {
        console.warn(e);
        await (new Promise((r) => setTimeout(r, 1000)));
        return window.tns(...args);
    }
};

const filtersExpires = new Date(Date.now() + 1000*60*60*24*365);

function wrapElementDiv(el, className) {
    const wrapper = document.createElement('div');
    if (className) {
        wrapper.className = className;
    }
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
}

function debounce(callee, timeoutMs) {
    let lastCall, lastCallTimer;
    const fn = function perform(...args) {
        let previousCall = lastCall
        lastCall = Date.now()
        if (previousCall && lastCall - previousCall <= timeoutMs) {
            clearTimeout(lastCallTimer)
        }
        lastCallTimer = setTimeout(() => callee(...args), timeoutMs)
    }
    fn.force = function (...args) {
        clearTimeout(lastCallTimer);
        return callee(...args);
    }
    return fn;
}
window.debounce = debounce;

function randomInteger(min, max) {
    let rand = min - 0.5 + Math.random() * (max - min + 1);
    return Math.round(rand);
}

const ClickOutside = {
    listeners: [],

    addListener(element, callback) {
        ClickOutside.listeners.push({
            element,
            callback: ClickOutside.createListenerCallbackHandler(element, callback),
        })
        ClickOutside.refreshWindowClickListener();
    },

    removeListener(element) {
        const listenerIndex = ClickOutside.listeners.findIndex((listener) => {
            return listener.element === element;
        })

        if (listenerIndex !== -1) {
            ClickOutside.listeners.splice(listenerIndex, 1);
            ClickOutside.refreshWindowClickListener();
        }
    },

    /* Trigger callback if clicked outside */
    createListenerCallbackHandler(
        element,
        callback,
    ) {
        return (event) => {
            const path = event.path || event.composedPath();
            const isClickOutside = path.indexOf(element) < 0;
            if (isClickOutside) {
                callback();
            }
        };
    },

    refreshWindowClickListener() {
        if (ClickOutside.listeners.length === 1) {
            window.addEventListener('mousedown', ClickOutside.handleWindowClick, true);
            window.addEventListener('touchstart', ClickOutside.handleWindowClick, true);
        }
        if (ClickOutside.listeners.length === 0) {
            window.removeEventListener('mousedown', ClickOutside.handleWindowClick);
            window.removeEventListener('touchstart', ClickOutside.handleWindowClick);
        }
    },

    handleWindowClick(event) {
        ClickOutside.listeners.forEach((listener) => {
            listener.callback(event);
        })
    }
}

class PlaceholderCount {
    constructor(el) {
        this.el = el;
        if(el) {
            this.placeholder = el.innerHTML;
        }
        else {
            console.warn('PlaceholderCount', el);
        }
    }

    setCount(count) {
        if(this.el) {
            if (count) {
                this.el.innerHTML = `${this.placeholder}<span>${count}</span>`;
            } else {
                this.el.innerHTML = this.placeholder;
            }
        }
        else {
            console.warn('Set PlaceholderCount is not element');
        }
    }
}

class SelectBase {
    constructor(el, triggerClass = 'trigger', multiple = false) {
        if(el && el[Symbol.iterator]) {
            if(!el.length) {
                return;
            }
            el = el[0];
        }
        this.el = el;
        this.multiple = multiple;
        this.baseClass = el.className.split(' ')[0];
        this.classActive = this.baseClass + '--active'
        this.classActiveItem = this.baseClass + '__item--active';

        this.valueEl = el.querySelector(`.${this.baseClass}__value`);
        this.listEls = el.querySelectorAll(`.${this.baseClass}__item`);
        this.inputEl = el.querySelector('input[type="hidden"]');
        this.trigger = el.querySelector(`.${this.baseClass}__${triggerClass}`);
        if(!this.trigger) {
            return console.warn('Not trigger select', this);
        }
        this.name = this.trigger.dataset.name;

        if (multiple) {
            this.valueEl.addEventListener('click', this.reset.bind(this));
        }
        this.trigger.addEventListener('click', this.toggle.bind(this));
        this.listEls.forEach(el => el.addEventListener('click', this.handleSelect.bind(this, el)));

        if (this.listEls.length > 8) {
            this.el.classList.add(`${this.baseClass}--large`);
        }

        this.initFromInput();

        this.inputEl.addEventListener('reset', () => {
            this.reset();
        })
        this.inputEl.addEventListener('set', () => {
            this.initFromInput();
        })
    }

    initFromInput() {
        if (this.inputEl.value.length) {
            const [list] = this.getValue();
            this.inputEl.value = '';
            const valueAll = list.join(',');
            list.forEach((value) => {
                this.listEls.forEach((el) => {
                    const valEl = this.getItemValue(el);
                    if (valEl === value.trim() || valEl === valueAll) {
                        el.click();
                    }
                })
            });
        }
    }

    reset(e) {
        if (e) {
            e.stopPropagation();
        }
        this.setInputVal('');
        this.valueEl.innerHTML = '';
        this.listEls.forEach(el => el.classList.remove(this.classActiveItem));
    }

    handleSelect(el) {
        if (!this.multiple) {
            this.listEls.forEach((el) => el.classList.remove(this.classActiveItem));
            this.close();
        }
        const value = this.getItemValue(el);
        return el.classList.toggle(this.classActiveItem, this.toggleValue(value, this.getItemLabel(el), (!this.multiple && value)))
    }

    getItemValue(el) {
        return el.dataset.value ? el.dataset.value.trim() : null;
    }

    getItemLabel(el) {
        return (el.dataset.label || el.innerText || '').trim();
    }

    toggleValue(val, label, forceAdd = false) {
        const [list, listLabels] = this.getValue();
        const hasAdd = val && (forceAdd || !list.includes(val));
        if (this.multiple) {
            let inputVal, labelVal;
            if (hasAdd) {
                labelVal = [...listLabels, label];
                inputVal = [...list, val];
            } else {
                labelVal = list.filter(item => item !== label);
                inputVal = list.filter(item => item !== val);
            }
            this.setInputVal(inputVal.join(','), labelVal.join(','));
            const valStr = labelVal.length > 1 ? `${labelVal.length} ${this.name || ''}` : labelVal[0];

            this.valueEl.innerHTML = inputVal.length ? `${valStr}`.trim() : '';
        } else {
            this.valueEl.innerHTML = hasAdd ? label : '';
            this.setInputVal(hasAdd ? val : '', this.valueEl.innerHTML);
        }
        return hasAdd;
    }

    getValue() {
        let result = [[], []];
        if (this.inputEl.value) {
            result[0] = this.inputEl.value.split(',').filter((v) => v !== '');
            if(this.inputEl.dataset.label) {
                result[1] = this.inputEl.dataset.label.split(',').filter((v) => v !== '')
            }
            else {
                result[1] = result[0];
            }
        }
        return result;
    }

    setInputVal(val, label = '') {
        this.inputEl.value = val != null ? val.trim() : undefined;
        this.inputEl.dataset.label = label;
        this.inputEl.dispatchEvent(new Event('input'));
        this.inputEl.dispatchEvent(new Event('change'));
    }

    open() {
        this.el.classList.add(this.classActive);
        ClickOutside.addListener(this.el, this.close.bind(this));
    }

    close() {
        this.el.classList.remove(this.classActive);
        ClickOutside.removeListener(this.el);
    }

    toggle() {
        if (this.trigger.tagName !== 'INPUT' && this.el.classList.contains(this.classActive)) {
            this.close();
        } else {
            this.open();
        }
    }
}

class HideBase {
    constructor(el, prefix, classItems, onShow, initIndex, animationMs = 0) {
        this.prefix = prefix;
        this.classActive = this.geClassActive(classItems);
        this.onShow = onShow;
        this.animationMs = animationMs;
        this.inited = false;

        const rootEl = el.closest(`[data-${prefix}-root]`);
        this.containers = this.getContainers(rootEl) || [];
        this.items = Array.from(el.querySelectorAll(this.getQueryEls(classItems)));
        this.items.forEach((el, index) => {
            const targetIndex = el.dataset[`${prefix}Target`];
            el.addEventListener('click', this.handler.bind(this, el, targetIndex || index, onShow));
            if (index === initIndex) {
                el.click();
            }
        });
        setTimeout(() => {
            if (onShow) {
                const activeContainerI = this.containers.findIndex((els) => els && !els[0].hasAttribute(`data-${this.prefix}-hide`));
                const activeEl = this.items.find((el) => el.classList.contains(this.classActive));
                if (activeEl && ~activeContainerI) {
                    this.emitOnShow(activeEl, this.containers[activeContainerI]);
                }
            }
            this.inited = true;
        }, 1);
    }

    geClassActive(className) {
        if (className.startsWith('*')) return 'HideBase--active';
        else return `${className}--active`
    }

    getQueryEls(classItems) {
        if (classItems.startsWith('*')) return classItems;
        else return `.${classItems}`;
    }

    getInitiatedEl(container) {
        return container.map((el) => el.querySelector(`[data-${this.prefix}-initiated]`));
    }

    isInitiated(container) {
        return container.some(el => el.hasAttribute(`data-${this.prefix}-initiated-done`));
    }

    setInitiated(containerList) {
        return containerList.forEach((el) => {
            el.setAttribute(`data-${this.prefix}-initiated-done`, '');
        })
    }

    getContainers(rootEl) {
        if (rootEl) {
            const list = Array.from(rootEl.querySelectorAll(`[data-${this.prefix}-index]`));
            return list.reduce((tmp, el) => {
                const key = el.dataset[`${this.prefix}Index`];
                key.split(',').forEach((key) => {
                    if (!tmp[key]) tmp[key] = [];
                    tmp[key].push(el);
                });
                return tmp;
            }, []);
        }
    }

    emitOnShow(item, containerList) {
        if (this.onShow) {
            this.onShow(item, this.getInitiatedEl(containerList), this.isInitiated(containerList));
            this.setInitiated(containerList);
        }
    }

    handler(el, index, onShow, e) {
        e.preventDefault();
        this.deactivationAll();
        el.classList.add(this.classActive);
        setTimeout(() => {
            const containerList = this.containers[index];
            if (containerList) {
                containerList.forEach((container) => {
                    container.removeAttribute(`data-${this.prefix}-hide`);
                });
                if (onShow) {
                    this.emitOnShow(el, containerList);
                }
            }
        }, this.inited ? +this.animationMs : 0);
    }

    deactivationAll() {
        this.items.forEach((el) => {
            el.classList.remove(this.classActive);
        })
        this.containers.forEach((list) => {
            list.forEach((el) => {
                el.setAttribute(`data-${this.prefix}-hide`, '');
            })
        })
    }
}

class GroupCheckbox {
    constructor(rootEl, inputsGroup, titleEl, placeholderEl, changeAllState) {
        this.inputs = [...rootEl.querySelectorAll(`${inputsGroup} input`)];
        this.allInput = rootEl.querySelector(`${titleEl} input`);
        this.placeholder = new PlaceholderCount(placeholderEl);
        this.changeAllState = changeAllState;

        this.calcCount();
        this.handleToggleAll();
        this.handleChangeInput();
    }

    handleToggleAll() {
        this.allInput.addEventListener('change', (e) => {
            this.inputs.forEach((el) => {
                el.checked = e.target.checked;
                el.dispatchEvent(new CustomEvent('change'));
            });
            this.callChangeAllState(e.target.checked);
            this.placeholder.setCount(e.target.checked ? this.inputs.length : 0);
        }, { passive: true });
    }

    handleChangeInput() {
        this.inputs.forEach((input) => {
            input.addEventListener('change', (e) => {
                if (e instanceof CustomEvent) return;
                this.calcCount();
            }, { passive: true });
        })
    }

    calcCount() {
        const count = this.inputs.filter((input) => input.checked).length;
        const newValue = count === this.inputs.length;
        if(newValue !== this.allInput.checked) {
            this.allInput.checked = newValue;
            this.callChangeAllState(newValue);
        }
        this.placeholder.setCount(count);
    }

    callChangeAllState(state) {
        if(this.changeAllState) {
            this.changeAllState(state, this);
        }
    }
}


class ModalCounter {
    constructor(modal, inputsQuery, format = (v) => v) {
        this.inputs = Array.from(modal.querySelectorAll(inputsQuery));
        this.placeholder = new PlaceholderCount(modal.querySelector('.modal__counter'));
        this.format = format;

        this.update();
        modal.querySelectorAll('input').forEach((input) => {
            input.addEventListener('change', (e) => {
                this.update();
            })
        });

        this.placeholder.el.addEventListener('click', () => {
            this.inputs.forEach((input) => input.checked && input.click());
            this.placeholder.setCount(0);
        });
    }

    update() {
        const count = this.inputs.filter((input) => input.checked).length;
        this.placeholder.setCount(count ? this.format(count) : 0)
    }
}

class SliderControlMouse {
    constructor(container, nav = false) {
        this.width = container.parentElement.clientWidth;
        this.initSlider(container, nav).then((slider) => {
            this.slider = slider;
            if (!window.$isMobile && this.slider) {
                this.count = container.childElementCount;
                this.itemWidth = this.width / this.count;
                this.lastIndex = this.slider.getInfo().index + 1;
                container.addEventListener('mousemove', this.handleMousemove.bind(this), { passive: true });
            }
        });
    }

    initSlider(container, nav) {
        return tns({
            container,
            items: 1,
            controls: false,
            nav: true,
            mouseDrag: true,
            loop: true,
            responsive: {
                768: {
                    nav,
                    loop: false,
                },
            },
        });
    }

    handleMousemove(e) {
        const index = Math.floor(e.layerX / this.itemWidth);
        if (this.lastIndex !== index) {
            this.slider.goTo(index);
            this.lastIndex = index;
        }
    }
}

class LoadMoreBtn {
    constructor(el, qMore, qItem, qHide, iniCb) {
        this.el = el;
        this.qMore = qMore;
        this.qItem = qItem;
        this.qHide = qHide;
        this.iniCb = iniCb;
        this.init();
    }

    init() {
        const more = this.el.querySelector(this.qMore);
        if (more) {
            more.addEventListener('click', () => {
                fetch(more.dataset.url)
                    .then((r) => r.text())
                    .then((html) => {
                        more.outerHTML = html;
                        this.init();

                        setTimeout(() => {
                            this.el.querySelectorAll(this.qItem).forEach((el) => {
                                if (this.iniCb) {
                                    this.iniCb(el);
                                }
                                if (this.qHide) {
                                    el.classList.remove(this.qHide.replace('.', ''));
                                }
                            })
                        }, 10);
                    });
            })
        }
    }
}


function declension(rawNumber, ...titles) { //отзыв, отзыва, отзывов
    let number = Math.floor(rawNumber);
    if (number !== rawNumber && rawNumber) {
        number = +rawNumber.toString().split('.').slice(-1)[0];//Последнее число
    }
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : ([2, 0, 1, 1, 1, 2])[Math.min(number % 10, 5)]]
}

function declensionWithCount(count, ...titles) {
    return `${count} ${declension(count, ...titles)}`
}


/* Declensions */
function declensionDistrict(count) {
    return declensionWithCount(count, 'район', 'района', 'районов');
}

function declensionStation(count) {
    return declensionWithCount(count, 'станция', 'станции', 'станций');
}


document.querySelectorAll('.InputBase input[type=number]').forEach((input) => {
    input.type = 'text';
    input.setAttribute('data-type', 'number');
    input.IMask = new IMask.InputMask(input, {
        mask: Number,
        min: getVal('min'),
        max: getVal('max') || null,
        thousandsSeparator: ' ',
    });

    function getVal(key) {
        const v = parseFloat(input.getAttribute(key));
        return isNaN(v) ? null : v;
    }
});


function checkInit(el, cb, attr = 'data-inited') {
    if (!el.hasAttribute(attr)) {
        el.setAttribute(attr, '');
        return cb();
    }
}

const CookieUtil = {
    get: function (name){
        var cookieName = encodeURIComponent(name) + "=",
            cookieStart = document.cookie.indexOf(cookieName),
            cookieValue = null,
            cookieEnd;

        if (cookieStart > -1){
            cookieEnd = document.cookie.indexOf(";", cookieStart);
            if (cookieEnd == -1){
                cookieEnd = document.cookie.length;
            }
            cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd));
        }

        return cookieValue;
    },

    set: function (name, value, expires, path, domain, secure) {
        var cookieText = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        if (expires instanceof Date) {
            cookieText += "; expires=" + expires.toGMTString();
        }

        if (path) {
            cookieText += "; path=" + path;
        }

        if (domain) {
            cookieText += "; domain=" + domain;
        }

        if (secure) {
            cookieText += "; secure";
        }


        document.cookie = cookieText;
        console.log(cookieText, this.get(name), window.isRestoringFilters);
    },

    unset: function (name, path, domain, secure){
        this.set(name, "", new Date(0), path, domain, secure);
    }

};
function goToSearch() {
    if(!location.pathname.startsWith('/map')) {
        location.pathname = '/search/';
    }
    else {
        location.reload();
    }
}
